(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-index"] && !Shopify.designMode) return;
  try {
    
// 横スクロール「次へ」ボタン（PCのみ動作）
document.querySelectorAll('.hs-wrap').forEach(function(wrap) {
  var btn = wrap.querySelector('.hs-next');
  var hs = wrap.querySelector('.hs');
  if (!btn || !hs) return;
  btn.addEventListener('click', function() {
    hs.scrollBy({ left: 188 * 3, behavior: 'smooth' });
  });
});

  } catch(e) { console.error(e); }
})();
})();
